import type { APIErrorResponse } from '~/redux/api/models';

export const errorSerializer = (
  error: APIErrorResponse,
  separator: string = ', '
): string => {
  if (!error.details) return error.error;

  return error.details.map((err) => err.msg).join(separator);
};
